import { render, staticRenderFns } from "./hal_contact.vue?vue&type=template&id=50431829&"
import script from "./hal_contact.vue?vue&type=script&lang=js&"
export * from "./hal_contact.vue?vue&type=script&lang=js&"
import style0 from "./hal_contact.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports